import * as React from "react"
import { cn } from "../../lib/utils"
import { useTheme } from "../../styles/ThemeProvider"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  const { themeObject } = useTheme();
  
  // Obtener tokens del tema actual
  const textareaTokens = themeObject.components.textarea || {};
  
  const textareaStyles = {
    minHeight: textareaTokens.minHeight || '80px',
    width: '100%',
    borderRadius: textareaTokens.borderRadius || themeObject.borderRadius?.md || '6px',
    border: `1px solid ${textareaTokens.borderColor || themeObject.colors.border.default}`,
    backgroundColor: textareaTokens.backgroundColor || themeObject.colors.background.default,
    padding: textareaTokens.padding || '8px 12px',
    fontSize: textareaTokens.fontSize || themeObject.typography?.fontSize?.sm || '14px',
    color: textareaTokens.color || themeObject.colors.text.primary,
    lineHeight: themeObject.typography?.lineHeight?.normal || '1.5',
    resize: 'vertical',
    outline: 'none',
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  };

  return (
    <textarea
      className={cn("flex disabled:cursor-not-allowed disabled:opacity-50", className)}
      style={textareaStyles}
      ref={ref}
      {...props}
    />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }